import { render } from "./JumpScare.vue?vue&type=template&id=3cc38b87&scoped=true"
import script from "./JumpScare.vue?vue&type=script&lang=js"
export * from "./JumpScare.vue?vue&type=script&lang=js"

import "./JumpScare.vue?vue&type=style&index=0&id=3cc38b87&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc38b87"]])

export default __exports__